import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import { TransferCandidate } from '../../../budget/project-import/types'
import { getBudgetPositionCount, getExternalPositionCount, getPhaseCount } from '../utils/budgetDataMapper'
import FormattedTotal from '../../../budget/components/FormattedTotal'

interface Props {
  budget: TransferCandidate
}

/**
 * Budget Details Panel Component
 *
 * Displays detailed information about selected budget including:
 * - Project name, client, study type, phase
 * - Duration and total budget
 * - Counts of positions and phases
 *
 * @example
 * <BudgetDetailsPanel budget={selectedBudget} />
 */
export const BudgetDetailsPanel: React.FC<Props> = ({ budget }) => {
  return (
    <Segment>
      <Header as="h4">Budget Details</Header>
      <p><strong>Project Name:</strong> {budget.name}</p>
      <p><strong>Client:</strong> {budget.client_name}</p>
      <p><strong>Study Type:</strong> {budget.study_type}</p>
      <p><strong>Phase:</strong> {budget.study_phase}</p>
      <p><strong>Duration:</strong> {budget.start_date} to {budget.end_date}</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
        <strong>Total Budget:</strong>
        <FormattedTotal amount={budget.total_budget} showLabel={false} />
      </div>
      <p>✓ {getBudgetPositionCount(budget)} Internal Positions</p>
      <p>✓ {getExternalPositionCount(budget)} External Positions</p>
      <p>✓ {getPhaseCount(budget)} Project Phases</p>
    </Segment>
  )
}

export default BudgetDetailsPanel
